import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_green/.local-data/work/about-page-b5f953ea2664f0a27afd0e595b68fc7f658e4721/build/src/app/error.tsx");
